/**
 @ngdoc directive
 @name loadDelay

 @description
Provides functionality to add a time delay to when sections of a page are loaded.

 @usage
<form>
    <div ng-repeat="item in array">
        <div id="unique_id" load-delay>
            <div ng-if="formModel.loadDelay.unique_id">
                content to load with a delay
            </div>
        </div>
    <div>
    <input type="submit" ng-disabled="formModel.loadDelay.allLoaded" />
</form>
 */

(function () {
  "use strict";
  var loadDelay = function ($timeout) {
    return {
      restrict: "A",

      link: function ($scope, $element) {
        if (!$scope.formModel.loadDelay) $scope.formModel.loadDelay = {};

        var obj = {};
        obj[$element[0].id] = false;

        Object.assign($scope.formModel.loadDelay, obj);
        $scope.formModel.loadDelay.allLoaded = false;

        angular.element(document).ready(function() {
          $timeout(function() {
            $scope.formModel.loadDelay[$element[0].id] = true;

            $scope.formModel.loadDelay.allLoaded =
              Object.keys($scope.formModel.loadDelay).findIndex(function (key) {
                if (key === "allLoaded") return false;
                return !$scope.formModel.loadDelay[key];
              }) === -1;
          }, 500)

        })

      },
    };
  };

  loadDelay.$inject = ["$timeout"];
  angular.module("app").directive("loadDelay", loadDelay);
})();
